import { Api, Codes } from '../api';
import store from '../store';
import { ROLES } from '../constants/role';
class School {
  constructor() {
    this.store = store;
    this.infoPromise;
  }
  get infoData() {
    return this.store.state.schoolLoginData;
  }
  getInfo() {
    if (this.infoPromise) {
      return this.infoPromise;
    } else {
      return (this.infoPromise = new Promise((resolve, reject) => {
        if (this.infoData && Object.keys(this.infoData).length) {
          resolve(this.infoData);
        } else {
          this.infoPromise = Api.get.getSchoolInfo().then(res => {
            this.infoPromise = null;
            if (res.status === Codes.SUCCESS) {
              let data = res.data;
              this.store.dispatch('setLoginData', {
                role: ROLES.SCHOOL,
                data: data
              });
              resolve(this.infoData);
            } else {
              reject(res);
            }
          });
        }
      }));
    }
  }
}
export default new School();
